import * as React from "react";
import {
    getProductList,
    getCar,
    getBookings,
    getProductSearchQuery
} from "../../../state/action";
import {
    updateProductList,
    changeProductAmount,
    updateRepList,
    updateSearchList,
    debitorPriceRequest,
    updateVINSearchList
} from "../../../state/product/action";
import { Dispatch, Action } from "redux";
import { connect } from "react-redux";
import { RootState } from "../../../state";
import { useEffect } from "react";
import { addProducts } from "../../../state/order/action";
import ProductGroup from "../ProductGroup";

import { updateProductSearchQuery } from "../../../state/ui/action";
import Search from "../../base/Search";
import { getUserInformation } from "../../../state/action";
import { userHasAccess } from "../../utils/UserHelper";
import PageHeader from "../../layout/PageHeader";
import "../style.css"
import { Spinner, SpinnerSize, Stack, Checkbox, DefaultButton } from "@fluentui/react";
import AutoValidVinSearch from "../AutoValidVinSearch";

let isVinSearching = false;
const ProductOverview: React.FunctionComponent<StateProps> = props => {
    const [showList, updateShowList] = React.useState<boolean>(false);
    const [products, setProducts] = React.useState<ProductGroup[]>(
        props.products
    );

    useEffect(() => {
        filterBySearchTerm();
    }, [props.products]);

    useEffect(() => {
        const { productSearchQuery } = props;
        if (
            productSearchQuery &&
            productSearchQuery.term
        ) {
            props.updateSearchList(
                {
                    term: productSearchQuery.term,
                    debitorNo: props.order.debitor.no
                },
                false
            );
        } else if (props.order.additionalData.orderType === "REPAIR") {
            props.updateRepList();
        } else if (props.car.carId) {
            props.updateProductList(
                props.car.carId,
                props.car.vehicleIdentificationNumber
                    ? props.car.vehicleIdentificationNumber
                    : "",
                    props.car.debitor ? props.car.debitor.no : "",
                    
            );
        }
        updateShowList(true);
    }, []);

    const debitorPriceRequest = (request: ProductPriceRequest[]) =>
        props.debitorPriceRequest(props.order.debitor.no, request, props.order.additionalData.whoIsPaying, props.order.car.insurance);

    const addProducts = (products: PurchaseItem[]) =>
        props.addProducts(products, props.order.debitor.no, props.order.additionalData.whoIsPaying, props.order.car.insurance);

    const search = (term: string) => {
        props.updateSearchList({ term, debitorNo: props.order.debitor.no }, true);
        props.updateSearchProductQuery(term);
    };

    const filterBySearchTerm = () => {
        setProducts(props.products);
    };
    const onClickVINSearch = async () => {
        if (!isVinSearching) {
            isVinSearching = true;
            await props.updateVINSearchList(
                props.car.vehicleIdentificationNumber,
                props.car.debitor ? props.car.debitor.no : ""
            );
            isVinSearching = false;
        }
    };

    const render = () => {
        if (showList) {
            let result: JSX.Element = <></>;
            if (props.car.carId !== undefined && props.products.length === 0) {
                result = <Spinner size={SpinnerSize.large} />;
            } else if (products.length === 0) {
                result = <p>Ingen produkter fundet</p>;
            } else {
                result = (
                    <ProductGroup
                        items={products}
                        order={props.order}
                        addProducts={addProducts}
                        changeAmount={props.changeProductAmount}
                        debitorPriceRequest={debitorPriceRequest}
                    />
                );
            }
            return (
                <Stack horizontal tokens={{ childrenGap: 50 }}>
                    <Stack.Item grow={2} className="product__search">
                        <div className="product__search-bar-wrapper">
                            <div className="product__search-bar-vinBtn-wrapper">
                                {userHasAccess(props.userInformation.roles, [
                                    "VINSearch"
                                ]) && (
                                    <DefaultButton onClick={onClickVINSearch}>
                                        VIN opslag
                                    </DefaultButton>
                                )}
                                {userHasAccess(props.userInformation.roles, ["AutovalidVINSearch"]) && (
                                <AutoValidVinSearch />
                                )}
                            </div>
                            <Search
                                query={props.productSearchQuery}
                                onSearch={search}
                                debitorNo={props.order.debitor.no}
                            />
                        </div>
                        {result}
                    </Stack.Item>
                </Stack>
            );
        }
    };

    return (
        <div>
            <PageHeader currentPage="Udskiftning af rude" />
            <div className="products__container">{render()}</div>
        </div>
    );
};

const mapStateToProps = (state: RootState) => {
    return {
        productSearchQuery: getProductSearchQuery(state),
        order: getBookings(state),
        products: getProductList(state),
        car: getCar(state),
        userInformation: getUserInformation(state)
    };
};

const mapToDispatchProps = (dispatch: Dispatch<Action>) => ({
    updateSearchList: (
        query: { term: string, debitorNo?: string },
        merge: boolean
    ) => dispatch<any>(updateSearchList(query, merge)),
    updateVINSearchList: (vinNumber: string | undefined, debitorNo: string) =>
        dispatch<any>(updateVINSearchList(vinNumber, debitorNo)),
    updateSearchProductQuery: (term?: string) =>
        dispatch<any>(updateProductSearchQuery(term)),
    updateProductList: (carId: number, vin: string, debitorNo: string) =>
        dispatch<any>(updateProductList(carId, vin, debitorNo)),
    addProducts: (products: PurchaseItem[], debitorNo: string, whoIsPaying: WhoIsPaying, insurance?: string) =>
        dispatch<any>(addProducts(products, debitorNo, whoIsPaying, insurance)),
    changeProductAmount: (productNo: string, amount: number) =>
        dispatch(changeProductAmount(productNo, amount)),
    updateRepList: () => dispatch<any>(updateRepList()),
    debitorPriceRequest: (debitor: string, request: ProductPriceRequest[], whoIsPaying: WhoIsPaying, insurance?: string) =>
        dispatch<any>(debitorPriceRequest(debitor, request, whoIsPaying, insurance))
});

type StateProps = ReturnType<typeof mapStateToProps> &
    ReturnType<typeof mapToDispatchProps>;

export default connect(mapStateToProps, mapToDispatchProps)(ProductOverview);
